import { PropsWithChildren } from 'react';
import { PageUrlMeta } from 'src/utils/getPageUrlMeta';
import { Footer } from '../Footer';
import { Header } from '../Header';
import * as S from './styles';

type Props = PropsWithChildren<{
  alternateLinks: PageUrlMeta['alternateLinks'];
}>;

export const PageLayout = ({ alternateLinks, children }: Props) => {
  return (
    <S.Layout>
      <Header alternateLinks={alternateLinks} />
      <S.Content>{children}</S.Content>
      <Footer />
    </S.Layout>
  );
};
